import React, { CSSProperties, FC, ReactElement, useState } from 'react'

import styles from '../styles/Modal.module.scss'
import iconStyles from '../styles/Icon.module.scss'
import { Icon } from './icons/Icon'

interface ModalProps {
	visible: boolean
	title: string
	content: ReactElement | string
	footer?: ReactElement | string
	style?: CSSProperties
	onClose: () => void
}

const Modal: FC<ModalProps> = ({ visible, title, content, footer, style = { width: '650px' }, onClose }) => {
	const [hidingProceed, setHidingProceed] = useState(false)

	const onKeydown = ({ key }: KeyboardEvent) => {
		switch (key) {
			case 'Escape':
				setHidingProceed(true)
				setTimeout(() => {
					onClose()
					setHidingProceed(false)
				}, 300)
				break
		}
	}

	const onCloseRef = () => {
		setHidingProceed(true)
		setTimeout(() => {
			onClose()
			setHidingProceed(false)
		}, 300)
	}

	React.useEffect(() => {
		document.addEventListener('keydown', onKeydown)
		return () => document.removeEventListener('keydown', onKeydown)
	})

	if (!visible) return null

	return (
		<div className={styles.modal} style={{ opacity: hidingProceed ? '0' : '1' }}>
			<div className={styles.modal_dialog} style={style} onClick={(e) => e.stopPropagation()}>
				<div className={styles.modal_header}>
					<h3
						className={styles.modal_header__title}
						style={{
							textAlign: 'center',
						}}
					>
						{title}
					</h3>
					<span className={styles.modal_header__close} onClick={onCloseRef}>
						<Icon variant={'xmark'} className={iconStyles.default} />
					</span>
				</div>
				<div
					className={styles.modal_body}
					style={{
						padding: '0px 0px',
					}}
				>
					<div className={styles.modal_body__content}>{content}</div>
				</div>
				{footer && <div className={styles.modal_footer}>{footer}</div>}
			</div>
		</div>
	)
}

export default Modal
